/**
 * RUT: canónico al guardar y comparar, formateado solo al mostrar.
 * Canónico: sin puntos ni espacios, con guion, DV en mayúscula → 96508210-7
 * Presentación: con puntos y guion → 96.508.210-7
 */

/** Canónico: sin puntos ni espacios, con guion, DV en mayúscula. */
export function normalizarRut(rut) {
  if (!rut) return '';
  return String(rut).trim().replace(/\./g, '').replace(/ /g, '').toUpperCase();
}

/** Presentación: 96508210-7 → 96.508.210-7. Solo para mostrar. */
export function formatearRut(rut) {
  const c = normalizarRut(rut);
  const [cuerpo, dv] = c.split('-');
  if (!cuerpo || !dv) return c; // no adivinar sobre basura
  return `${cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${dv}`;
}

/**
 * Variantes de un RUT para búsqueda de texto libre: canónica, formateada y
 * solo-caracteres. Así la fila se encuentra escriba el usuario `96508210-7`,
 * `96.508.210-7` o `965082107`.
 */
export function variantesBusquedaRut(rut) {
  const canonico = normalizarRut(rut);
  if (!canonico) return [];
  return [canonico, formatearRut(canonico), canonico.replace(/[^0-9K]/g, '')];
}
